<card-container
  class="card-container {{ FirstCommentTourClasses.activityCard }}"
  [ngClass]="{ 'viewed': !unviewedState(activity) }"
  #cardContainer
  (contextmenu)="openMenu($event, activity)"
  (click)="goToActivity(activity)"
  (keyup.enter)="goToActivity(activity)"
  data-cy="activity-row-or-card"
  tabindex="0"
  role="link"
  [attr.aria-label]="activity.name"
  [matTooltip]="activity.name"
  [matTooltipDisabled]="!activityNameTruncated">
  <div main class="content">
    <div class="attention-needed">
      <dot-indicator
        [activity]="activity"
        [hasBorder]="true"
        [size]="12">
      </dot-indicator>
    </div>
    <div class="activity-icon">
      <i class="{{ isParentChildSyncEnabled(activity) ? 'ficon-activity-locked' : 'ficon-assignment' }}"></i>
    </div>
  </div>
  <div
    info-first-line
    detectTextTruncation
    (truncatedChange)="handleTruncatedChange($event)"
    >
    {{ activity.name }}
  </div>
  <div info-second-line></div>
  <div info-third-line>
    @if (activity.due_at && shouldShowDueDate()) {
      <div class="info due-date">
        <ngx-activity-due-date [activity]="activity"></ngx-activity-due-date>
      </div>
    }
    <div class="info status">
      <ngx-activity-list-status [activity]="activity"></ngx-activity-list-status>
    </div>
  </div>

  <div info-third-line-action-btns (keyup.enter)="$event.stopPropagation();">
    @if (activity.unviewed_comments) {
      <comment-indicator
        [unviewedComments]="activity.unviewed_comments">
      </comment-indicator>
    }

    <!-- #region Menu Button -->
    @if (canOpenMenu()) {
      <button
        class="menu-btn btn-none"
        data-cy="activity-options-dropdown-menu"
        [attr.aria-label]="'session-list-item_view-options' | translate"
        (click)="openMenu($event, activity)"
        (keyup.enter)="$event.stopPropagation();">
        <i class="ficon-app-dots-vertical"></i>
      </button>
    }
    <!-- endregion -->

    <menu>
      <activity-menu [activity]="selectedActivity"></activity-menu>
    </menu>
  </div>
</card-container>
